<section>
  <h2>Alerts</h2>
  <p>Create a unique Alert Name, select yout geographic filters based on the case agency's location, and click "+Add Alert" to subscribe to a daily summary email alert.</p>
  <p-messages key="lePartnerFormMsg" [closable]="true"></p-messages>
  <form [formGroup]="manageAlertsInputForm" class="mb-3 w-lg-75">
    <div class="mb-2">
      <label for="AlertName" class="form-label font-size-sm required-field">Alert Name</label>
      <input id="AlertName" type="text" formControlName="AlertName" class="form-control form-control-sm" aria-label="Alert Name" maxlength="100" nessAutoFocus/>
      <div class="invalid-feedback" *ngIf="manageAlertsInputForm.get('AlertName').invalid">
        {{ alertNameErrorMessage }}
      </div> 
    </div>
    <div class="mb-2">
      <label for="fieldDivisionsFilter" class="form-label font-size-sm required-field">Field Division</label>
      <select class="form-select form-select-sm" formControlName="FieldDivisionID" id="fieldDivisionsFilter" name="FieldDivisionID" (change)="onSelectFieldDivision($event['target'])">
        <ng-container *ngIf="fieldDivisions$ | async as fieldDivisions">
          <option *ngFor="let fieldDiv of fieldDivisions" [value]="fieldDiv.FieldDivisionID">{{fieldDiv.FieldDivisionName}}</option>
        </ng-container>
      </select>
    </div>
    <div class="mb-2">
      <label for="FieldDivisionGroupId" class="form-label font-size-sm">Field Division Group</label>
      <ng-container *ngIf="fieldDivisionGroups$ | async as groups">
        <p-multiSelect #groupms formControlName="FieldDivisionGroups" [options]="groups" optionLabel="GroupName" name="GroupName" placeholder="All" optionDisabled="Inactive" dataKey="IntelligenceReportATFReferralGroupsID" inputId="FieldDivisionGroupId" styleClass="form-select form-select-sm" ariaFilterLabel="Filter by field division group name" [maxSelectedLabels]="3" [showToggleAll]="false" (onChange)="onSelectFDGroup($event)" [resetFilterOnHide]="true" filterBy="GroupName" [virtualScroll]="true" [virtualScrollItemSize]="30">
          <ng-template let-selectedGroup pTemplate="selectedItems">
            <ng-container *ngIf="!!selectedGroup && selectedGroup.length <= 3">
              <span *ngFor="let group of selectedGroup; last as isLast">{{group.GroupName}}<span *ngIf="!isLast">; </span> </span>
            </ng-container>
            <ng-container *ngIf="!!selectedGroup && selectedGroup.length > 3">{{ selectedGroup.length }} items selected</ng-container>
            <ng-container *ngIf="!selectedGroup || selectedGroup.length === 0">All</ng-container>
          </ng-template>
          <ng-template let-group pTemplate="item">
            <div>{{group.GroupName}} ({{group.Inactive | booleanTransform: 'Inactive' :'Active'}})</div>
          </ng-template>
        </p-multiSelect>
      </ng-container>
    </div>
    <div class="mb-2">
      <label for="statesFilter" class="form-label font-size-sm">State</label>
      <select class="form-select form-select-sm" formControlName="StateID" id="statesFilter" name="StateID" (change)="onSelectState($event['target'])">
        <option value="">All</option>
        <ng-container *ngIf="states$ | async as states">
          <option *ngFor="let state of states" [value]="state.StateID">{{state.StateName}}</option>
        </ng-container>
      </select>
    </div>
    <div class="mb-2">
      <label for="countiesFilter" class="form-label font-size-sm">County(ies)</label>
      <ng-container *ngIf="counties$ | async as counties">
        <p-multiSelect #countyms formControlName="Counties" [options]="counties" optionLabel="CountyNme" name="counties" placeholder="All" dataKey="CountyID" inputId="countiesFilter" styleClass="form-select form-select-sm" ariaFilterLabel="Filter by county name" [maxSelectedLabels]="3" [showToggleAll]="false" (onChange)="onSelectCounties($event)" [resetFilterOnHide]="true" filterBy="CountyName" [virtualScroll]="true" [virtualScrollItemSize]="30">
          <ng-template let-selectedCounties pTemplate="selectedItems">
            <ng-container *ngIf="!!selectedCounties && selectedCounties.length <= 3">
              <span *ngFor="let county of selectedCounties; last as isLast">{{county.CountyName}}, {{county.ENESS_REF_State.StateAbbreviation}}<span *ngIf="!isLast">; </span> </span>
            </ng-container>
            <ng-container *ngIf="!!selectedCounties && selectedCounties.length > 3">{{ selectedCounties.length }} items selected</ng-container>
            <ng-container *ngIf="!selectedCounties || selectedCounties.length === 0">All</ng-container>
          </ng-template>
          <ng-template let-county pTemplate="item">
            <div>{{county.CountyName}}, {{county.ENESS_REF_State?.StateAbbreviation}}</div>
          </ng-template>
        </p-multiSelect>
      </ng-container>
    </div>
    <div class="mb-2">
      <label for="agenciesFilter" class="form-label font-size-sm">LE Agency</label>
      <ng-container *ngIf="agencies$ | async as agencies">
        <p-multiSelect #agencyms formControlName="Agencies" [options]="agencies" optionLabel="AgencyName" name="AgencyName" placeholder="All" dataKey="AgencyID" inputId="agenciesFilter" styleClass="form-select form-select-sm" ariaFilterLabel="Filter by county name" [maxSelectedLabels]="3" [showToggleAll]="false" [resetFilterOnHide]="true" filterBy="AgencyName" [virtualScroll]="true" [virtualScrollItemSize]="30">
          <ng-template let-selectedAgencies pTemplate="selectedItems">
            <ng-container *ngIf="!!selectedAgencies && selectedAgencies.length <= 3">
              <span *ngFor="let agency of selectedAgencies; last as isLast">{{agency.AgencyName}}<span *ngIf="!isLast">; </span> </span>
            </ng-container>
            <ng-container *ngIf="!!selectedAgencies && selectedAgencies.length > 3">{{ selectedAgencies.length }} items selected</ng-container>
            <ng-container *ngIf="!selectedAgencies || selectedAgencies.length === 0">All</ng-container>
          </ng-template>
        </p-multiSelect>
      </ng-container>
    </div>
    <div class="d-flex mb-2">
      <button type="button" [disabled]="!manageAlertsInputForm.valid || (maxAlertCount <= currentAlertCount && !inEditMode)" (click)="onSaveAlert()" class="btn btn-sm btn-success ms-auto me-2"> <i *ngIf="!inEditMode" class="fas fa-plus" aria-hidden="true"></i> {{ btnLabel }}</button>
      <button *ngIf="inEditMode" type="button" (click)="onCancel()" class="btn btn-sm btn-secondary" label="Cancel">Cancel</button>
    </div>
  </form>
  <h3>All Geographic Filter Alerts <span class="font-size-sm">(maximum {{ maxAlertCount }})</span></h3>
  <p-table #alertTable [columns]="cols" [value]="alertsViewModel" selectionMode="single" editMode="row" [(selection)]="selectedAlert" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [customSort]="true" [autoLayout]="true" responsiveLayout="scroll" stateStorage="session">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" scope="col">
          {{col.header}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
      <tr>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'CreatedOrModifiedDate'">{{rowData?.CreatedOrModifiedDate | localToUtc:'MM/dd/yyyy'}}</ng-container>
          <ng-container *ngSwitchCase="'AlertName'">{{rowData?.AlertName}}</ng-container>
          <ng-container *ngSwitchCase="'FieldDivisionName'">{{rowData?.FieldDivisionName}}</ng-container>
          <ng-container *ngSwitchCase="'FieldDivisionGroupName'">{{ (rowData?.FieldDivisionGroupName ? rowData?.FieldDivisionGroupName : 'All')}}</ng-container>
          <ng-container *ngSwitchCase="'StateName'">{{ (rowData?.StateName ? rowData?.StateName : 'All') }}</ng-container>
          <ng-container *ngSwitchCase="'CountyName'">{{ (rowData?.CountyName ? rowData?.CountyName : 'All') }}</ng-container>
          <ng-container *ngSwitchCase="'AgencyName'">{{ (rowData?.AgencyName ? rowData?.AgencyName : 'All') }}</ng-container>
          <ng-container *ngSwitchCase="'AlertsUserRequest_CrimeGunCasesID'">
            <div class="d-flex justify-content-center">
              <button aria-label="Edit alert row" pButton type="button" icon="pi pi-pencil" class="p-button-info me-2" (click)="onRowEditAlert(rowData, i)" title="Edit alert row"></button>
              <button aria-label="Delete alert row" pButton type="button" icon="pi pi-times" class="p-button-danger" (click)="onRowDeleteAlert(rowData, i)" title="Delete alert row"></button>
            </div>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          No alerts found.
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="my-2">
    <button type="button" (click)="showManageAlertForm.emit(false)" class="btn btn-sm btn-active">Close</button>
  </div>
</section>

